import React from 'react';
import { Button, InlineNotification, Loader } from '@ui';
import { translatorFor } from './i18n';
const t = translatorFor('lazy_section');
const LOADER_SIZE = '24';
export function LazyState({ loading, error, onRetry }) {
    if (loading)
        return React.createElement(Loader, { size: LOADER_SIZE, title: t('loading') });
    if (!error)
        return null;
    return (React.createElement(InlineNotification, { variant: "warning", action: React.createElement(Button, { variant: "tertiary", onClick: onRetry }, t('retry')) }, t('error')));
}
export function RefreshButton({ disabled, onRefresh }) {
    return (React.createElement(Button, { variant: "tertiary", disabled: disabled, onClick: onRefresh }, t('refresh')));
}
